import React from 'react';
import { Button, Divider, Icon } from 'semantic-ui-react';
import DyzioModal from 'dyzio-shared-components/lib/components/dyzio-modal';
import TargetLink from '../target-link';

const HELP_URL = 'https://dyzio.co/track-paid-campaign-data';

export default class ConnectAccount extends React.Component {
  constructor() {
    super();
    this.state = {
      modalOpen: false,
    };
  }

  toggleModalState = () => this.setState({
    modalOpen: !this.state.modalOpen,
  })

  render() {
    const { modalOpen } = this.state;
    return (
      <div>
        <p>
        You have not linked a facebook ads manager account.
        Click <a onClick={this.toggleModalState}>here</a> to link your account.
        This will enable you to create Paid & organic reports for your campaigns.
        This is a premium feature - find out more <TargetLink renderIf href={HELP_URL}>here</TargetLink>.
        </p>
        <Divider />
        <Button onClick={this.toggleModalState} inverted fluid icon labelPosition="left" color="pink">
          <Icon name="linkify" />
          Link my account
        </Button>
        {
          modalOpen && (
            <DyzioModal
              size="tiny"
              onClose={this.toggleModalState}
              headerText="Linking Facebook Ads Manager Account"
              hasActionButton
              actionButtonContent="OK"
              onActionButtonClick={this.toggleModalState}
            >
              <p>
                This is a premium feature - find out more <TargetLink renderIf href={HELP_URL}>here</TargetLink>.
                Contact a member of our sales team using the chat tool in the bottom right to get set up.
              </p>
            </DyzioModal>
          )
        }
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/facebook-connect-account/index.js
 **/